import PImg1 from "../assets/blog-images/img1.JPG"
import PImg2 from "../assets/blog-images/img2.JPG"
import PImg3 from "../assets/blog-images/img3.JPG"
import PImg5 from "../assets/blog-images/img5.jpeg"

import SrImg1 from "../assets/blog-images/sr-trip/img1.jpeg"
import SrImg2 from "../assets/blog-images/sr-trip/img2.jpeg"
import SrImg3 from "../assets/blog-images/sr-trip/img3.jpeg"
import SrImg4 from "../assets/blog-images/sr-trip/img4.jpeg"
import SrImg5 from "../assets/blog-images/sr-trip/img5.jpeg"
import SrImg6 from "../assets/blog-images/sr-trip/img6.jpeg"
import SrImg7 from "../assets/blog-images/sr-trip/img7.JPG"
import SrImg8 from "../assets/blog-images/sr-trip/img8.jpeg"
import SrImg9 from "../assets/blog-images/sr-trip/img9.jpeg"
import SrImg10 from "../assets/blog-images/sr-trip/img10.jpeg"
import SrImg11 from "../assets/blog-images/sr-trip/img11.jpeg"
import SrImg12 from "../assets/blog-images/sr-trip/img12.JPG"
import SrImg13 from "../assets/blog-images/sr-trip/img13.jpeg"

import HighImg1 from '../assets/blog-images/highschool/img1.jpeg'
import HighImg2 from '../assets/blog-images/highschool/img2.jpeg'
import HighImg3 from '../assets/blog-images/highschool/img3.jpeg'
import HighImg4 from '../assets/blog-images/highschool/img4.jpeg'
import HighImg5 from '../assets/blog-images/highschool/img5.jpeg'
import HighImg6 from '../assets/blog-images/highschool/img6.jpeg'

import BacImg1 from '../assets/blog-images/bac2/img1.jpeg'
import BacImg2 from '../assets/blog-images/bac2/img2.JPG'
import BacImg3 from '../assets/blog-images/bac2/img3.jpeg'
import BacImg4 from '../assets/blog-images/bac2/img4.PNG'
import BacImg5 from '../assets/blog-images/bac2/img5.PNG'
import BacImg6 from '../assets/blog-images/bac2/img6.jpeg'
import BacImg7 from '../assets/blog-images/bac2/img7.jpeg'
import BacImg8 from '../assets/blog-images/bac2/img8.jpeg'
import BacImg9 from '../assets/blog-images/bac2/img9.jpeg'
import BacImg10 from '../assets/blog-images/bac2/img10.jpeg'
import BacImg11 from '../assets/blog-images/bac2/img11.PNG'
import BacImg12 from '../assets/blog-images/bac2/img12.jpg'
import BacImg13 from '../assets/blog-images/bac2/img13.jpg'

import CodingImg1 from '../assets/blog-images/coding/img1.jpeg'
import CodingImg2 from '../assets/blog-images/coding/img2.jpeg'
import CodingImg3 from '../assets/blog-images/coding/img3.JPG'
import CodingImg4 from '../assets/blog-images/coding/img4.JPG'
import CodingImg5 from '../assets/blog-images/coding/img5.JPG'


export const BlogImageList = {
    personal: [ PImg1, PImg2, PImg3, PImg5 ],
    srtrip: [ SrImg1, SrImg2, SrImg3, SrImg4, SrImg5, SrImg6, SrImg13, SrImg7, SrImg8, SrImg9, SrImg10, SrImg11, SrImg12 ],
    highschool: [ HighImg1, HighImg2, HighImg3, HighImg4, HighImg5, HighImg6 ],
    bac2: [ BacImg12, BacImg13, BacImg11, BacImg4, BacImg5, BacImg6, BacImg7, BacImg8, BacImg9, BacImg10, BacImg3 , BacImg1, BacImg2 ],
    coding: [ CodingImg1, CodingImg2, CodingImg3, CodingImg4, CodingImg5 ]
}